export default __webpack_public_path__ + "static/media/SearchIcon.228b57a6.svg";